"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const styles_1 = require("@material-ui/core/styles");
const TextareaAutosize_1 = __importDefault(require("@material-ui/core/TextareaAutosize"));
const formik_1 = require("formik");
const useStyles = styles_1.makeStyles((theme) => ({
    root: {
        padding: '10px',
        borderColor: theme.palette.text.primary,
        fontSize: '16px',
        borderRadius: '5px',
        width: '100%',
    },
}));
const RenderTextAreaField = (props) => {
    const { field: { value, name, onChange, onBlur }, form: { touched, errors, setFieldValue }, label, placeholder, rows, ...otherProps } = props;
    const error = formik_1.getIn(errors, name);
    const touch = formik_1.getIn(touched, name);
    const classes = useStyles();
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(Box_1.default, { paddingY: 2 },
            label && (react_1.default.createElement(Typography_1.default, Object.assign({ variant: "subtitle2" }, otherProps), label)),
            react_1.default.createElement(TextareaAutosize_1.default, Object.assign({ name: name, className: classes.root, value: value || '', rowsMin: rows, onChange: onChange, placeholder: placeholder, onBlur: (event) => {
                    setFieldValue(name, event.target.value.trim());
                    onBlur(event);
                } }, otherProps)),
            touch && !!error && (react_1.default.createElement(Typography_1.default, Object.assign({ variant: "body2", component: "p", color: "error" }, otherProps), error)))));
};
RenderTextAreaField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    label: prop_types_1.default.string.isRequired,
    placeholder: prop_types_1.default.string,
    rows: prop_types_1.default.number.isRequired,
};
exports.default = RenderTextAreaField;
